import React from "react";
import { TextField, Card, Box } from "@material-ui/core";
import { Lang, Save } from "components";
import { useText } from "hooks";
import useStore from "context";
import { checkAllFields } from "helpers/throwErrorEmptiField";
import { useTranslation } from "localization/translation";

export const OfferForm = ({ title, initialData, onSave, fixedLang }) => {
  const { lang, setErrorMsg } = useStore();
  const translation = useTranslation();
  const [text, , , input] = useText(initialData);
  const fieldLang = fixedLang || lang;

  const submitForm = (e) => {
    e.preventDefault();
    const payload = {
      kind: text.kind,
      title_en: text.title_en,
      title_ru: text.title_ru,
      title_hy: text.title_hy,
      text_en: text.text_en,
      text_ru: text.text_ru,
      text_hy: text.text_hy,
    };
    const fieldsToCheck = fixedLang
      ? {
          kind: payload.kind,
          [`title_${fixedLang}`]: payload[`title_${fixedLang}`],
          [`text_${fixedLang}`]: payload[`text_${fixedLang}`],
        }
      : payload;
    checkAllFields(fieldsToCheck, setErrorMsg, () => onSave(payload));
  };

  return (
    <Card className="shadow-xxl px-4 py-2 mb-4">
      <Box className="pt-3">
        <h4 className="mb-0">{title}</h4>
      </Box>
      <Box component="form" onSubmit={submitForm} mb={4}>
        {!fixedLang && <Lang />}
        <TextField {...input(`title_${fieldLang}`)} label={translation.title} />
        <TextField
          {...input(`text_${fieldLang}`)}
          multiline
          rows={8}
          label={translation.text}
        />
        <Save />
      </Box>
    </Card>
  );
};
